var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ix-form-input-large-options',{attrs:{"options":_setup.impactProfileOptions,"value":_vm.value,"is-editable":!_vm.disabled,"is-multiple":false},on:{"input":(val) => _setup.emit('input', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }